import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/globals/globals';
import { EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';
import { Items, ItemsByEnquiryNo } from 'src/app/shared/models/data/itemsByEnquiryNo.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { CalculatedCols, CustomIcoCol, GridDataset } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';
import { map } from 'rxjs/operators';
import { signal, effect } from '@angular/core';


export class CloseEnquiryData {
  enquiryNo?: string;
  lostReasonId?: number | null;
  closureReason?: string;
  bookedItems?: { itemNo: string, sapItemNo: number | null, sapPriceType?: string | null, materialCode: string, applicationId?: number | null, sapDeliveryDate?: number | null }[] | null;
  sendToSAP?: boolean;
  salesOrgId?: number | null;
  applicationId?: number | null;
}

@Component({
  selector: 'app-close-enquiry',
  templateUrl: './close-enquiry.component.html',
  styleUrls: ['./close-enquiry.component.scss']
})
export class CloseEnquiryComponent {

  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() enquiryNo: string = "";
  @Input() enquiryStatus: string = "";
  @Input() columnsToShowItem!: string[];
  @Input() customIcoCols: CustomIcoCol[] = [];
  @Input() calculatedCols!: CalculatedCols[];
  @Input() customRenderers: any;
  @Input() customHeaderRenderers: any;

  @Output() closeCloseEnquiryModal: EventEmitter<any> = new EventEmitter();
  @Output() closeEnquiry: EventEmitter<CloseEnquiryData> = new EventEmitter();

  closureReasons: SelectOption[] = new Array();
  lostReasons: SelectOption[] = new Array();
  salesOrgs: SelectOption[] = new Array();
  applications: SelectOption[] = new Array();
  lostReasonRequired: boolean = false;
  lostReasonDisabled: boolean = true;
  salesOrgRequired: boolean = false;
  applicationRequired: boolean = false;
  closureReason: any;
  lostReason: any;
  salesOrg: any;
  application: any;
  sapPriceTypeSelection: any;
  closureReasonIsValid: boolean = true;
  lostReasonIsValid: boolean = true;
  salesOrgIsValid: boolean = true;
  applicationIsValid: boolean = true;
  clearLostReason: boolean = false;
  isDummyCustomer: boolean = false;
  items = signal<Items[]>([]);
  enquiryItemsSource: Items[] = [];
  selectedItems: any[] = [];
  customRenderersToUse: any = {};
  customHeaderRenderersToUse: any = {};
  sapPriceTypeOptions: SelectOption[] = [];
  columnsToShowItemWithApplication: string[] = [];
  showItemDeliveryDates: boolean = false;
  selectedDeliveryDatesItem?: EnquiryHeaderItem | null = null;

  @ViewChild('costHeaderCell', { static: true }) costHeaderCell!: TemplateRef<any>;
  @ViewChild('costValueCell', { static: true }) costValueCell!: TemplateRef<any>;
  @ViewChild('deliveryDateCell', { static: true }) deliveryDateCell!: TemplateRef<any>;
  @ViewChild('materialCodeCell', { static: true }) materialCodeCell!: TemplateRef<any>;
  @ViewChild('sapItemNoCell', { static: true }) sapItemNoCell!: TemplateRef<any>;
  @ViewChild('sapPriceUomCell', { static: true }) sapPriceUomCell!: TemplateRef<any>;
  @ViewChild('sapPriceCell', { static: true }) sapPriceCell!: TemplateRef<any>;
  @ViewChild('applicationCell', { static: true }) applicationCell!: TemplateRef<any>;
  @ViewChild('sapDeliveryDateCell', { static: true }) sapDeliveryDateCell!: TemplateRef<any>;

  private readonly costHeaderUomByColumn: { [key: string]: string } = {
    initialPrice: 'costsUom',
    previousRevisionPrice: 'costsUom',
    finalPricePerLength: 'finalPricePerLengthUom',
    finalPricePerPiece: 'finalPricePerPieceUom',
    totalPrice: 'totalPriceUom',
    alloySurchargeValue: 'costsUom',
    energySurchargeValue: 'costsUom',
    fullCost: 'costsUom',
    minimumPrice: 'costsUom',
    recommendedPrice: 'costsUom',
    extraCosts: 'costsUom',
    finalPrice: 'finalPriceUom',
    actualFmAmountPerWeight: 'costsUom'
  };


  constructor(public globals: Globals, private loader: TeiasoftLoaderService, private backendService: BackendService,
    private teiasoftToaster: TeiasoftToasterService, private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.buildCustomRenderers();
    this.buildCustomHeaderRenderers();
    this.updateColumnsToShowItem();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["enquiryNo"]) {
      this.enquiryNo = changes["enquiryNo"].currentValue;
      if (this.enquiryNo) {
        this.getEnquiryClosureStatusesAndLostReasons();
      }
    }

    if (changes && changes["customRenderers"]) {
      this.customRenderers = changes["customRenderers"].currentValue;
      this.buildCustomRenderers();
    }

    if (changes && changes["customHeaderRenderers"]) {
      this.customHeaderRenderers = changes["customHeaderRenderers"].currentValue;
      this.buildCustomHeaderRenderers();
    }

    if (changes && changes["columnsToShowItem"]) {
      this.columnsToShowItem = changes["columnsToShowItem"].currentValue;
      this.updateColumnsToShowItem();
    }
  }

  getDataSetItems(enquiryItems: any) {
    let dataSetItems = new Array();
    for (var i = 0; i < enquiryItems.length; i++) {
      let _dataSet: GridDataset = new GridDataset();
      let _obj: Items = new Items();
      _obj = enquiryItems[i]!;
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (_value == null) _value = "";
        let _typeOf: string = typeof _value;
        let _key: string = "";
        if (_typeOf != 'object') {
          _dataSet[key] = _value;
        } else {
          if (Array.isArray(_value)) {
            _key = key;
            if (_value.length == 0) {
              _dataSet[_key] = '';
            }
            if (_value.length > 0 && key.toLowerCase() == 'attachments') {
              _dataSet[_key] = _value.length;
            } else {
              for (const key2 in _value[0]) {
                _key = key + "." + key2;
                //_dataSet[key2] = _value.map(x => x[key2]).join(',');
                _dataSet[_key] = _value.map(x => x[key2]).join(',');
              }
            }

          } else {
            for (const key3 in _value) {
              if (typeof _value[key3] != 'object') {
                _key = key + "." + key3;
                let _value3: any = _value[key3 as keyof typeof _value];
                //_dataSet[key3] = _value3;
                _dataSet[_key] = _value3;
              } else {
                for (const key4 in _value[key3]) {
                  _key = key + "." + key3 + "." + key4;
                  let _value4: any = _value[key3][key4]; //_value[key4 as keyof typeof key4];
                  //_dataSet[key4] = _value4;
                  _dataSet[_key] = _value4;
                }
              }
            }
          }
        }
      }
      _dataSet["sapItemNo"] = this.getInitialSapItemNo(_obj.customerItemNo);
      _dataSet["sapDeliveryDate"] = this.getInitialSapDeliveryDate(_obj);
      this.setSapPriceSelection(_dataSet, this.getDefaultSapPriceType(_dataSet));
      dataSetItems.push(_dataSet);
    }

    dataSetItems = dataSetItems.sort(
      function (a, b) {
        return a["itemNo"]! - b["itemNo"]!;
      }
    );

    return dataSetItems;
  }

  buildCustomRenderers() {
    if (!this.costValueCell || !this.deliveryDateCell || !this.materialCodeCell || !this.sapItemNoCell || !this.sapPriceUomCell || !this.sapPriceCell || !this.applicationCell || !this.sapDeliveryDateCell) return;
    const baseRenderers = this.customRenderers || {};
    this.customRenderersToUse = {
      ...baseRenderers,
      ["finalPricePerPiece"]: (row: any) => {
        return {
          template: this.costValueCell,
          context: { $implicit: row, column: 'finalPricePerPiece' }
        };
      },
      ["deliveryDate"]: (row: any) => {
        return {
          template: this.deliveryDateCell,
          context: { $implicit: row, column: 'deliveryDate' }
        };
      },
      ["sapItemNo"]: (row: any) => {
        return {
          template: this.sapItemNoCell,
          context: { $implicit: row, column: 'sapItemNo' }
        };
      },
      ["sapPriceUom"]: (row: any) => {
        return {
          template: this.sapPriceUomCell,
          context: { $implicit: row, column: 'sapPriceUom' }
        };
      },
      ["sapPrice"]: (row: any) => {
        return {
          template: this.sapPriceCell,
          context: { $implicit: row, column: 'sapPrice' }
        };
      },
      ["material.materialCode"]: (row: any) => {
        return {
          template: this.materialCodeCell,
          context: { $implicit: row, column: 'material.materialCode' }
        };
      },
      ["applicationId"]: (row: any) => {
        return {
          template: this.applicationCell,
          context: { $implicit: row, column: 'applicationId' }
        };
      },
      ["sapDeliveryDate"]: (row: any) => {
        return {
          template: this.sapDeliveryDateCell,
          context: { $implicit: row, column: 'sapDeliveryDate' }
        };
      }
    };
  }

  buildCustomHeaderRenderers() {
    if (!this.costHeaderCell) return;

    const baseHeaderRenderers = this.customHeaderRenderers || {};
    this.customHeaderRenderersToUse = { ...baseHeaderRenderers };

    Object.keys(this.costHeaderUomByColumn).forEach((column) => {
      this.customHeaderRenderersToUse[column] = () => {
        return {
          template: this.costHeaderCell,
          context: { column }
        };
      };
    });
  }

  onSapItemNoInput(evt: Event, row: any) {
    const rawValue = (evt.target as HTMLInputElement).value ?? '';
    const sanitizedValue = rawValue.replace(/\D/g, '');
    (evt.target as HTMLInputElement).value = sanitizedValue;

    row["sapItemNo"] = sanitizedValue === '' ? '' : parseInt(sanitizedValue, 10);

    const selectedIndex = this.selectedItems.findIndex(i => i.itemNo === row.itemNo);
    if (selectedIndex !== -1) {
      this.selectedItems[selectedIndex]["sapItemNo"] = row["sapItemNo"];
    }
  }

  onSapPriceTypeChange(evt: Event, row: any) {
    const sapPriceType = (evt.target as HTMLSelectElement).value;
    this.setSapPriceSelection(row, sapPriceType || null);
  }

  onMaterialCodeInput(evt: Event, row: any) {
    const value = (evt.target as HTMLInputElement).value;
    row["material.materialCode"] = value;
    if (!row.material) row.material = {};
    row.material.materialCode = value;

    const selectedIndex = this.selectedItems.findIndex(i => i.itemNo === row.itemNo);
    if (selectedIndex !== -1) {
      this.selectedItems[selectedIndex]["material.materialCode"] = value;
      if (!this.selectedItems[selectedIndex].material) this.selectedItems[selectedIndex].material = {};
      this.selectedItems[selectedIndex].material.materialCode = value;
    }
  }

  onSapDeliveryDateChange(value: string, row: any) {
    const normalizedValue = value === undefined || value === null || value === '' ? '' : Number(value);
    row["sapDeliveryDate"] = normalizedValue === '' || Number.isNaN(normalizedValue) ? '' : normalizedValue;

    const selectedIndex = this.selectedItems.findIndex(i => i.itemNo === row.itemNo);
    if (selectedIndex !== -1) {
      this.selectedItems[selectedIndex]["sapDeliveryDate"] = row["sapDeliveryDate"];
    }
  }

  hasMissingMaterialCodes(): boolean {
    if (this.selectedItems.length == 0) return false;
    return this.selectedItems.some(item => this.getMaterialCodeValue(item) === '');
  }

  hasMissingSapItemNos(): boolean {
    if (this.selectedItems.length == 0) return false;
    return this.selectedItems.some(item => this.getSapItemNoValue(item) === null);
  }

  hasDuplicateSapItemNos(): boolean {
    if (this.selectedItems.length == 0) return false;

    const sapItemNos = this.selectedItems
      .map(item => this.getSapItemNoValue(item))
      .filter((value): value is number => value !== null);

    return new Set(sapItemNos).size !== sapItemNos.length;
  }

  hasMissingSapPriceTypes(): boolean {
    if (this.selectedItems.length == 0) return false;
    return this.selectedItems.some(item => !item?.sapPriceType);
  }

  hasMissingSapDeliveryDates(): boolean {
    if (this.selectedItems.length == 0) return false;
    return this.selectedItems.some(item => this.getSapDeliveryDateValue(item) === null);
  }

  isCloseActionDisabled(): boolean {
    return this.closureReason == 'Won' && (this.selectedItems.length == 0 && this.items().length > 0);
  }

  isSendToSapDisabled(): boolean {
    return this.items().length == 0 || this.isDummyCustomerWonSelected() || this.hasSelectedDummyRawMaterialGrade();
  }

  showDummyCustomerWonWarning(): boolean {
    return this.isDummyCustomerWonSelected();
  }

  getSapPriceOptions(row: any): SelectOption[] {
    const options: SelectOption[] = [];
    this.addSapPriceOption(options, row, 'finalPrice', row?.finalPriceUom, row?.finalPrice);
    this.addSapPriceOption(options, row, 'finalPricePerLength', row?.finalPricePerLengthUom, row?.finalPricePerLength);
    this.addSapPriceOption(options, row, 'finalPricePerPiece', row?.finalPricePerPieceUom, row?.finalPricePerPiece);
    return options;
  }

  private getMaterialCodeValue(row: any): string {
    const directValue = row?.["material.materialCode"];
    if (directValue !== undefined && directValue !== null) return directValue.toString().trim();
    const nestedValue = row?.material?.materialCode;
    if (nestedValue !== undefined && nestedValue !== null) return nestedValue.toString().trim();
    return '';
  }

  private getSapItemNoValue(row: any): number | null {
    const value = row?.["sapItemNo"];
    if (value === undefined || value === null || value === '') return null;

    const parsedValue = parseInt(value.toString(), 10);
    return Number.isInteger(parsedValue) ? parsedValue : null;
  }

  private getSapDeliveryDateValue(row: any): number | null {
    const value = row?.["sapDeliveryDate"];
    if (value === undefined || value === null || value === '') return null;

    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  private addSapPriceOption(options: SelectOption[], row: any, sapPriceType: string, uom: string, price: number | null | undefined | string) {
    if (!uom || price === null || price === undefined || price == '') return;

    const option = new SelectOption();
    option.value = sapPriceType;
    option.text = uom;
    options.push(option);
  }

  private buildSapPriceTypeOptions(): SelectOption[] {
    const options: SelectOption[] = [];
    this.addMassSapPriceOption(options, 'finalPrice', this.items().find(item => item?.finalPriceUom)?.finalPriceUom);
    this.addMassSapPriceOption(options, 'finalPricePerLength', this.items().find(item => item?.finalPricePerLengthUom)?.finalPricePerLengthUom);
    this.addMassSapPriceOption(options, 'finalPricePerPiece', this.items().find(item => item?.finalPricePerPieceUom && item?.finalPricePerPiece !== null && item?.finalPricePerPiece !== undefined)?.finalPricePerPieceUom);
    return options;
  }

  private addMassSapPriceOption(options: SelectOption[], sapPriceType: string, uom?: string) {
    if (!uom) return;

    const option = new SelectOption();
    option.value = sapPriceType;
    option.text = uom;
    options.push(option);
  }

  private getDefaultSapPriceType(row: any): string | null {
    const options = this.getSapPriceOptions(row);
    if (options.length === 0) return null;

    const preferredUom = `${this.getPriceCurrency(row)}/${this.isHollowBarsItem(row) ? 'kg' : 'm'}`;
    const preferredOption = options.find(option => this.normalizeUom(option.text) === this.normalizeUom(preferredUom));

    return preferredOption?.value?.toString() ?? options[0]?.value?.toString() ?? null;
  }

  private getPriceCurrency(row: any): string {
    const uom = row?.finalPriceUom || row?.finalPricePerLengthUom || row?.finalPricePerPieceUom || row?.costsUom || '';
    const currency = uom.toString().split('/')[0]?.trim();
    return currency || '';
  }

  private setSapPriceSelection(row: any, sapPriceType: string | null | undefined) {
    if (!sapPriceType || !this.hasSapPriceTypeOption(row, sapPriceType)) {
      row.sapPriceType = '';
      row.sapPriceUom = '';
      row.sapPrice = '';
    } else {
      row.sapPriceType = sapPriceType;
      row.sapPriceUom = this.getSapPriceUomByType(row, sapPriceType);
      row.sapPrice = this.getSapPriceValueByType(row, sapPriceType);
    }

    const selectedIndex = this.selectedItems.findIndex(i => i.itemNo === row.itemNo);
    if (selectedIndex !== -1) {
      this.selectedItems[selectedIndex].sapPriceType = row.sapPriceType;
      this.selectedItems[selectedIndex].sapPriceUom = row.sapPriceUom;
      this.selectedItems[selectedIndex].sapPrice = row.sapPrice;
    }
  }

  private hasSapPriceTypeOption(row: any, sapPriceType: string): boolean {
    return this.getSapPriceOptions(row).some(option => option.value === sapPriceType);
  }

  private getSapPriceUomByType(row: any, sapPriceType: string): string {
    switch (sapPriceType) {
      case 'finalPrice':
        return row?.finalPriceUom ?? '';
      case 'finalPricePerLength':
        return row?.finalPricePerLengthUom ?? '';
      case 'finalPricePerPiece':
        return row?.finalPricePerPieceUom ?? '';
      default:
        return '';
    }
  }

  private getSapPriceValueByType(row: any, sapPriceType: string): number | '' {
    switch (sapPriceType) {
      case 'finalPrice':
        return row?.finalPrice ?? '';
      case 'finalPricePerLength':
        return row?.finalPricePerLength ?? '';
      case 'finalPricePerPiece':
        return row?.finalPricePerPiece ?? '';
      default:
        return '';
    }
  }

  getItemRowMinDeliveryDate(row: any): string {
    const item = this.enquiryItemsSource.find(i => i.itemNo === row.itemNo);

    const minWeeks = item?.deliveryDatesCollection
      ?.map(dd => dd.deliveryNumberOfWeeksWithExtraLeadTime)
      .filter((weeks): weeks is number => typeof weeks === 'number' && weeks > 0)
      .reduce((min, current) => Math.min(min, current), Infinity);

    return minWeeks === undefined || minWeeks === Infinity ? '' : this.formatWeeks(minWeeks);
  }

  getItemRowDeliveryDatesCollection(row: any) {
    const item = this.enquiryItemsSource.find(i => i.itemNo === row.itemNo);
    return item?.deliveryDatesCollection || [];
  }

  onItemDeliveryDatesClick(item: any) {
    this.selectedDeliveryDatesItem = this.enquiryItemsSource.find(i => i.itemNo == item.itemNo) as EnquiryHeaderItem | undefined ?? null;
    this.showItemDeliveryDates = this.selectedDeliveryDatesItem != null;
  }

  getCostColumnHeaderLabel(column: string): string {
    const baseLabel = this.getTranslatedColumnLabelWithoutUom(column);
    const uomColumn = this.costHeaderUomByColumn[column];
    const uomValue = this.getCostColumnUom(uomColumn);
    return uomValue ? `${baseLabel} (${uomValue})` : baseLabel;
  }

  private formatWeeks(weeks: number): string {
    return `${weeks} week${weeks > 1 ? 's' : ''}`;
  }

  private getCostColumnUom(uomColumn?: string): string {
    if (!uomColumn) {
      return '';
    }

    const fromGrid = (this.items() as any[]).find(item => !!item?.[uomColumn])?.[uomColumn];
    return fromGrid ?? '';
  }

  private getTranslatedColumnLabelWithoutUom(column: string): string {
    const translationKey = 'grid.' + column.charAt(0).toUpperCase() + column.slice(1);
    const translatedLabel = this.translate.instant(translationKey);
    return this.stripHardcodedUomSuffix(translatedLabel);
  }

  private stripHardcodedUomSuffix(label: string): string {
    return (label || '').replace(/\s*\(?[^\s()]+\/[^\s()]+\)?\s*$/, '').trim();
  }

  onRowSelection($event: any[]) {
    this.selectedItems = $event;
    if (this.application !== undefined && this.application !== null && this.application !== '') {
      this.applyApplicationToItems(this.application, false);
    }
    if (this.sapPriceTypeSelection !== undefined && this.sapPriceTypeSelection !== null && this.sapPriceTypeSelection !== '') {
      this.applySapPriceTypeToItems(this.sapPriceTypeSelection, false);
    }
  }

  getEnquiryClosureStatusesAndLostReasons() {
    this.loader.start();
    this.isDummyCustomer = false;
    this.backendService.getEnquiryClosureStatusesAndLostReasons(this.enquiryNo).subscribe(res => {
      this.isDummyCustomer = res.isDummyCustomer === true;
      this.closureReasons = new Array();
      this.lostReasons = new Array();
      this.salesOrgs = new Array();
      this.applications = new Array();
      for (var x = 0; x < res.closureStatuses!.length; x++) {
        let _item: SelectOption = new SelectOption();
        _item.text = res.closureStatuses![x];
        _item.value = res.closureStatuses![x];
        this.closureReasons.push(_item);
      }

      if (res.lostReasons) {
        for (var x = 0; x < res.lostReasons!.length; x++) {
          let _item: SelectOption = new SelectOption();
          _item.text = res.lostReasons![x].description;
          _item.value = res.lostReasons![x].lostReasonId;
          this.lostReasons.push(_item);
        }
      }

      if (res.salesOrgs) {
        for (var x = 0; x < res.salesOrgs!.length; x++) {
          let _item: SelectOption = new SelectOption();
          const code = res.salesOrgs![x].code || '';
          const description = res.salesOrgs![x].description || '';
          if (code && description) {
            _item.text = `${code} - ${description}`;
          } else {
            _item.text = code || description;
          }
          _item.value = res.salesOrgs![x].salesOrgId;
          this.salesOrgs.push(_item);
        }
      }

      if (res.applications) {
        for (var x = 0; x < res.applications!.length; x++) {
          let _item: SelectOption = new SelectOption();
          const code = res.applications![x].code || '';
          const description = res.applications![x].description || '';
          if (code && description) {
            _item.text = `${code} - ${description}`;
          } else {
            _item.text = code || description;
          }
          _item.value = res.applications![x].applicationId;
          this.applications.push(_item);
        }
      }

      const includeSapFields = !!res.closureStatuses?.some(status => status === 'Won');
      this.loadItemsForCloseEnquiry(includeSapFields);
    }, () => {
      this.loader.stop();
    });
  }

  isFormValid(sendToSAP: boolean): boolean {
    let _isValid: boolean = true;
    if (this.closureReason == '' || this.closureReason == undefined) {
      this.closureReasonIsValid = false;
      _isValid = false;
    }

    if (this.closureReason == 'Lost' && (this.lostReason == '' || this.lostReason == undefined)) {
      this.lostReasonIsValid = false;
      _isValid = false;
    }

    if (sendToSAP && (this.salesOrg == '' || this.salesOrg == undefined)) {
      this.salesOrgIsValid = false;
      _isValid = false;
    }

    if (sendToSAP && (this.application == '' || this.application == undefined)) {
      this.applicationIsValid = false;
      _isValid = false;
    }

    if (!_isValid) this.teiasoftToaster.show("error", this.translate.instant("errors.fieldMandatory"));
    return _isValid;
  }

  /* EVENTS */
  onSelectedClosure(evt: SelectOption) {
    this.closureReason = evt.value;
    this.closureReasonIsValid = true;
    this.lostReasonIsValid = true;
    this.salesOrgIsValid = true;
    this.applicationIsValid = true;

    if (evt.value == "Lost") {
      this.lostReasonRequired = true;
      this.lostReasonDisabled = false;
    } else {
      this.lostReason = '';
      //this.clearLostReason = true;
      //setTimeout(() => this.clearLostReason = false, 100);
      this.lostReasonRequired = false;
      this.lostReasonDisabled = true;
    }

    if (evt.value != "Won") {
      this.salesOrg = '';
      this.salesOrgIsValid = true;
      this.salesOrgRequired = false;
      this.application = '';
      this.applicationIsValid = true;
      this.applicationRequired = false;
      this.sapPriceTypeSelection = '';
      this.applyApplicationToItems(null, true);
    }
  }

  onSelectedlostReason(evt: SelectOption) {
    this.lostReasonIsValid = true;
    this.lostReason = evt.value;
  }

  onSelectedSalesOrg(evt: SelectOption) {
    this.salesOrgIsValid = true;
    this.salesOrg = evt.value;
  }

  onSelectedApplication(evt: SelectOption) {
    this.applicationIsValid = true;
    this.application = evt.value;
    this.applyApplicationToItems(evt.value, true);
  }

  onSelectedSapPriceType(evt: SelectOption) {
    this.sapPriceTypeSelection = evt.value;
    this.applySapPriceTypeToItems(evt.value, true);
  }

  onApplicationSelectChange(evt: Event, row: any) {
    const value = (evt.target as HTMLSelectElement).value;
    if (value === '') {
      this.updateItemApplication(row, null);
      return;
    }
    this.updateItemApplication(row, Number(value));
  }

  onCloseEnquiryClick(sendToSAP: boolean = false) {
    if (sendToSAP && (this.isDummyCustomerWonSelected() || this.hasSelectedDummyRawMaterialGrade())) {
      return;
    }

    if (sendToSAP && this.closureReason == 'Won' && this.hasMissingSapItemNos()) {
      this.teiasoftToaster.show("error", this.translate.instant("errors.missingSapItemNos"));
      return;
    }

    if (sendToSAP && this.closureReason == 'Won' && this.hasDuplicateSapItemNos()) {
      this.teiasoftToaster.show("error", this.translate.instant("errors.duplicateSapItemNos"));
      return;
    }

    if (sendToSAP && this.closureReason == 'Won' && this.hasMissingSapPriceTypes()) {
      this.teiasoftToaster.show("error", this.translate.instant("errors.missingSapPriceType"));
      return;
    }

    if (sendToSAP && this.closureReason == 'Won' && this.hasMissingMaterialCodes()) {
      this.teiasoftToaster.show("error", this.translate.instant("errors.missingMaterialCodes"));
      return;
    }

    if (sendToSAP && this.closureReason == 'Won' && this.hasMissingSapDeliveryDates()) {
      this.teiasoftToaster.show("error", this.translate.instant("errors.missingSapDeliveryDates"));
      return;
    }

    this.salesOrgRequired = sendToSAP;
    this.applicationRequired = sendToSAP;
    if (!sendToSAP) this.salesOrgIsValid = true;
    if (!sendToSAP) this.applicationIsValid = true;
    if (this.isFormValid(sendToSAP)) {
      let _data: CloseEnquiryData = new CloseEnquiryData();
      _data.enquiryNo = this.enquiryNo;
      _data.closureReason = this.closureReason;
      _data.lostReasonId = this.lostReason;
      _data.sendToSAP = sendToSAP;
      if (sendToSAP) _data.salesOrgId = this.salesOrg;
      if (sendToSAP) _data.applicationId = this.application;
      _data.bookedItems = this.selectedItems.length > 0 ? this.selectedItems.map(i => {
        const bookedItem: { itemNo: string; sapItemNo: number | null; sapPriceType?: string | null; materialCode: string; applicationId?: number | null; sapDeliveryDate?: number | null } = {
          itemNo: i.itemNo!,
          sapItemNo: this.getSapItemNoValue(i),
          sapPriceType: i.sapPriceType || null,
          materialCode: this.getMaterialCodeValue(i),
          sapDeliveryDate: this.getSapDeliveryDateValue(i)
        };
        bookedItem.applicationId = this.getApplicationValue(i);
        return bookedItem;
      }) : undefined;
      this.closeEnquiry.emit(_data);
    }
  }

  onCloseModalClick() {
    this.closeCloseEnquiryModal.emit('');
  }

  private updateColumnsToShowItem() {
    const columns = this.columnsToShowItem ? [...this.columnsToShowItem] : [];
    const hasSapItemNo = columns.some(col => col.toLowerCase() === 'sapitemno');
    if (!hasSapItemNo) {
      const customerItemIndex = columns.findIndex(col => col.toLowerCase() === 'customeritemno');
      if (customerItemIndex >= 0) {
        columns.splice(customerItemIndex + 1, 0, 'sapItemNo');
      } else {
        columns.unshift('sapItemNo');
      }
    }

    const hasApplication = columns.some(col => col.toLowerCase() === 'applicationid');
    if (!hasApplication) {
      const materialIndex = columns.findIndex(col => col.toLowerCase() === 'material.materialcode');
      if (materialIndex >= 0) {
        columns.splice(materialIndex + 1, 0, 'applicationId');
      } else {
        columns.push('applicationId');
      }
    }

    this.insertColumnBefore(columns, 'finalPrice', 'sapPriceUom');
    this.insertColumnBefore(columns, 'finalPrice', 'sapPrice');
    this.insertColumnAfter(columns, 'finalPricePerLength', 'finalPricePerPiece');
    this.insertColumnAfter(columns, 'deliveryDate', 'sapDeliveryDate');

    this.columnsToShowItemWithApplication = columns;
  }

  private applyApplicationToItems(applicationId: number | null | undefined, force: boolean) {
    const dataSetItems = this.items() as any[];
    if (!dataSetItems || dataSetItems.length === 0) return;
    if (!this.selectedItems || this.selectedItems.length === 0) return;
    const selectedItemNos = new Set(this.selectedItems.map(i => i.itemNo));
    dataSetItems.forEach((row: any) => {
      if (!selectedItemNos.has(row.itemNo)) return;
      if (!force && row.applicationId !== undefined && row.applicationId !== null && row.applicationId !== '') return;
      row.applicationId = applicationId ?? '';
      this.updateItemApplication(row, row.applicationId);
    });
  }

  private applySapPriceTypeToItems(sapPriceType: string | null | undefined, force: boolean) {
    const dataSetItems = this.items() as any[];
    if (!dataSetItems || dataSetItems.length === 0) return;
    if (!this.selectedItems || this.selectedItems.length === 0) return;

    const selectedItemNos = new Set(this.selectedItems.map(i => i.itemNo));
    dataSetItems.forEach((row: any) => {
      if (!selectedItemNos.has(row.itemNo)) return;
      if (!force && row.sapPriceType !== undefined && row.sapPriceType !== null && row.sapPriceType !== '') return;
      this.setSapPriceSelection(row, sapPriceType);
    });
  }

  private updateItemApplication(row: any, applicationId: number | null | undefined) {
    row.applicationId = applicationId ?? '';
    const selectedIndex = this.selectedItems.findIndex(i => i.itemNo === row.itemNo);
    if (selectedIndex !== -1) {
      this.selectedItems[selectedIndex].applicationId = applicationId ?? '';
    }
  }

  private getApplicationValue(row: any): number | null | undefined {
    const rowValue = row?.applicationId;
    if (rowValue !== undefined && rowValue !== null && rowValue !== '') return rowValue;
    if (this.application !== undefined && this.application !== null && this.application !== '') return this.application;
    return null;
  }

  private insertColumnBefore(columns: string[], targetColumn: string, newColumn: string) {
    const hasColumn = columns.some(col => col.toLowerCase() === newColumn.toLowerCase());
    if (hasColumn) return;

    const targetIndex = columns.findIndex(col => col.toLowerCase() === targetColumn.toLowerCase());
    if (targetIndex >= 0) {
      columns.splice(targetIndex, 0, newColumn);
    } else {
      columns.push(newColumn);
    }
  }

  private insertColumnAfter(columns: string[], targetColumn: string, newColumn: string) {
    const hasColumn = columns.some(col => col.toLowerCase() === newColumn.toLowerCase());
    if (hasColumn) return;

    const targetIndex = columns.findIndex(col => col.toLowerCase() === targetColumn.toLowerCase());
    if (targetIndex >= 0) {
      columns.splice(targetIndex + 1, 0, newColumn);
    } else {
      columns.push(newColumn);
    }
  }

  private getInitialSapItemNo(customerItemNo?: string): number | '' {
    if (!customerItemNo) return '';

    const parsedValue = parseInt(customerItemNo, 10);
    return Number.isInteger(parsedValue) ? parsedValue : '';
  }

  private getInitialSapDeliveryDate(item: Items): number | '' {
    const value = item.deliveryDateForSap?.deliveryDate;
    return typeof value === 'number' && !Number.isNaN(value) ? value : '';
  }

  hasMultipleDeliveryDatesForSap(row: any): boolean {
    return row?.["deliveryDateForSap.hasMultipleDeliveryDates"] === true
      || row?.deliveryDateForSap?.hasMultipleDeliveryDates === true;
  }

  private loadItemsForCloseEnquiry(includeSapFields: boolean): void {
    this.backendService.getItemsByEnquiryNo(this.enquiryNo, includeSapFields, includeSapFields)
      .pipe(map(res => res.items || []))
      .subscribe(items => {
        this.loader.stop();
        this.enquiryItemsSource = items;
        const dataSetItems = this.getDataSetItems(items);
        this.items.set(dataSetItems);
        this.sapPriceTypeOptions = this.buildSapPriceTypeOptions();
        this.selectedItems = dataSetItems;

        if (this.application !== undefined && this.application !== null && this.application !== '') {
          this.applyApplicationToItems(this.application, false);
        }
        if (this.sapPriceTypeSelection !== undefined && this.sapPriceTypeSelection !== null && this.sapPriceTypeSelection !== '') {
          this.applySapPriceTypeToItems(this.sapPriceTypeSelection, false);
        }
      }, () => {
        this.loader.stop();
      });
  }

  getSapDeliveryDateWarningTooltip(): string {
    return this.translate.instant('enquiryBook.multipleDeliveryDatesForSapWarning');
  }

  private isHollowBarsItem(row: any): boolean {
    const smsDescription = row?.["sms.description"] ?? row?.sms?.description ?? '';
    return smsDescription.toString().trim().toUpperCase() === 'HOLLOW BARS';
  }

  private normalizeUom(uom: any): string {
    return (uom ?? '').toString().trim().toUpperCase();
  }

  private isDummyCustomerWonSelected(): boolean {
    return this.closureReason == 'Won' && this.isDummyCustomer;
  }

  private hasSelectedDummyRawMaterialGrade(): boolean {
    return this.closureReason == 'Won' && this.selectedItems.some(item => item['rawMaterialGrade.isDummy'] === true);
  }
}
